import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import LandingPage from "./components/LandingPage";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Opportunities from "./pages/Opportunities";
import Professionals from "./pages/Professionals";
import PostRequirement from "./pages/PostRequirement";
import ProfilePreferences from "./pages/ProfilePreferences";
import SavedJobs from "./pages/SavedJobs";
import Inbox from "./pages/Inbox";
import Dashboard from "./pages/Dashboard";
import Messages from "./pages/Messages";
import AdminPost from "./pages/AdminPost";
import AdminInbox from "./pages/AdminInbox";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/opportunities" element={<Opportunities />} />
            <Route path="/professionals" element={<Professionals />} />
            <Route path="/post-requirement" element={<PostRequirement />} />
            <Route path="/tell-us" element={<ProfilePreferences />} />
            <Route path="/saved" element={<SavedJobs />} />
            <Route path="/inbox" element={<Inbox />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/messages/:id" element={<Messages />} />
            <Route path="/admin" element={<AdminPost />} />
            <Route path="/admin/inbox" element={<AdminInbox />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" />
      </AuthProvider>
    </div>
  );
}

export default App;
